import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { authStorage } from '../../utils/storage';

const IS_STAGING = process.env.REACT_APP_STAGING === 'true';

function AppShell({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  // Mobile navigation drawer. Off-canvas below the sidebar breakpoint; the
  // Topbar hamburger opens it, the overlay or a route change closes it.
  const [navOpen, setNavOpen] = useState(false);
  useEffect(() => { setNavOpen(false); }, [location.pathname]);

  const handleLogout = async () => {
    const token = authStorage.getToken();
    try {
      await fetch('/api/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (_) {}
    authStorage.clearAuthData();
    navigate('/login');
  };

  return (
    <div className={`app-shell${navOpen ? ' nav-open' : ''}`}>
      <Sidebar onLogout={handleLogout} open={navOpen} onClose={() => setNavOpen(false)} />
      <div
        className="nav-overlay"
        onClick={() => setNavOpen(false)}
        aria-hidden={!navOpen}
      />
      <main className="app-main">
        {IS_STAGING && (
          <div style={{
            background: '#f97316', color: '#ffffff', textAlign: 'center',
            fontSize: 13, fontWeight: 700, padding: '6px 12px',
            letterSpacing: '0.02em', lineHeight: 1.4,
          }}>
            ⚠ STAGING — Test environment. This is NOT the live database; changes here don’t affect production.
          </div>
        )}
        <Topbar onMenu={() => setNavOpen(true)} />
        <div className="app-content screen-fade">
          {children != null ? children : <Outlet />}
        </div>
      </main>
    </div>
  );
}

export default AppShell;
